exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b4171a6a] .el-dialog__body{padding:0.13333rem}", ""]);

// exports
